<h1 [ngClass]="{
  'text-lg md:text-2xl': fontSize === 1,
  'text-xl md:text-2xl': fontSize === 2,
  'text-2xl md:text-3xl': fontSize === 3,
  'uppercase': isUppercase
}" class="  px-6 font-bold  " [innerHTML]="title"></h1>